<template>
	<div class="legend">
		<div>
			<span class="legendColor" style="background: #c4c4c4;"></span>
			<span style="color: #c4c4c4;">离线</span>
		</div>
		<div>
			<span class="legendColor" style="background: #44ce18;"></span>
			<span style="color: #44ce18;">优&nbsp;&nbsp;</span>
		</div>
		<div>
			<span class="legendColor" style="background: #f0db30;"></span>
			<span style="color: #f0db30;">良&nbsp;&nbsp;</span>
		</div>
		<div>
			<span class="legendColor" style="background: #ffaa00;"></span>
			<span style="color: #ffaa00;">轻度</span>
		</div>
		<div>
			<span class="legendColor" style="background: #f2413b;"></span>
			<span style="color: #f2413b;">中度</span>
		</div>
		<div>
			<span class="legendColor" style="background: #9a034a;"></span>
			<span style="color: #9a034a;">重度</span>
		</div>
		<div>
			<span class="legendColor" style="background: #7e0320;"></span>
			<span style="color: #7e0320;">严重</span>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    
  },
  mounted() {

  }
};
</script>

<style scoped lang="less">
.legend {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: fixed;
  z-index: 100;
  bottom: 0rem;
  right: 0rem;
  text-align: left;
  padding: 0.1rem;
  font-size: 0.14rem;
  cursor: pointer;
  background: #081422;
  opacity:0.8;
  &>div{
    display: inline-block;
    margin: 0px 2px;
  }
  .onlymap {
    width: 8px;
    height: 8px;
    border-radius: 100%;
    display: inline-block;
    cursor: pointer;
  }
  .legendColor {
    display: inline-block;
    width: 0.3rem;
    height: 0.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/legend.vue